import React, { useEffect, useRef, useState } from 'react';
import { PayPalCard } from './PayPalCard';

// Copia de containers/Payment/PayPal/screens/components/PayPalAccountsGrid.js.
// El original navegaba con `navigate(..., { state: { screen, account } })`;
// aquí la cuenta seleccionada sube por callback y vive en el estado local de
// PayPalScreen, para no tocar `location.state` (que transporta qrUserData).
export const PayPalAccountsGrid = ({ accounts, onSelectAccount }) => {
  const gridRef = useRef(null);
  const [showTopFade, setShowTopFade] = useState(false);
  const [showBottomFade, setShowBottomFade] = useState(false);

  const isScrollable = accounts?.length > 6;

  useEffect(
    () => {
      if (!isScrollable || !gridRef.current) return;

      const el = gridRef.current;

      const updateFades = () => {
        const { scrollTop, scrollHeight, clientHeight } = el;
        setShowTopFade(scrollTop > 4);
        setShowBottomFade(scrollTop + clientHeight < scrollHeight - 4);
      };

      updateFades();
      el.addEventListener('scroll', updateFades);

      return () => el.removeEventListener('scroll', updateFades);
    },
    [accounts?.length, isScrollable],
  );

  return (
    <div className="paypal-cards__grid-wrapper">
      {showTopFade && (
        <div className="paypal-cards__fade paypal-cards__fade--top" />
      )}
      {showBottomFade && (
        <div className="paypal-cards__fade paypal-cards__fade--bottom" />
      )}

      <div
        ref={gridRef}
        className={`paypal-cards__grid ${
          isScrollable ? 'paypal-cards__grid--scrollable' : ''
        }`}
      >
        {accounts?.map(account => (
          <PayPalCard
            key={account?.paymentTokenId || account?.accountId || account?.email}
            email={account?.email}
            action={() => onSelectAccount?.(account)}
          />
        ))}
      </div>
    </div>
  );
};

export default PayPalAccountsGrid;
